module.exports = __webpack_public_path__ + "static/media/city-small.3c21c13e.svg";